import { lazy } from 'react';

// Types
import { PayPalButtonProps as LazyComponentProps } from './PayPalButton.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "payPalButton" */ './PayPalButton')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PayPalButton');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PayPalButton };
